<template>
    <div class="betslip__controls">
        <div  class="betslip__controls-left">
            <div class="betslip__controls-event-info">
                <span class="betslip__controls-events-info-label">{{ `${selectionNames}:` | capitalize }}</span>
                <span class="betslip__controls-events-info-number">{{ selectionsCount }}</span>
            </div>
            <div class="betslip__controls-actions">
                <button
                    v-if="undoSelections && !isOfflineTicket"
                    @click="$emit('undoClear')"
                    class="betslip__controls-action"
                >
                    <span>{{ $t('undo') | capitalize }}</span>
                    <i class="icon icon-arrow_left"></i>
                </button>
                <button
                    v-else-if="!isOfflineTicket"
                    @click="$emit('clear')"
                    class="betslip__controls-action"
                >
                    <span>{{ $t('remove all') | capitalize }}</span>
                    <i class="icon icon-delete"></i>
                </button>
                <div
                    v-if="isOfflineTicket"
                    class="betslip__controls-event-info"
                >
                    <span class="betslip__controls-events-info-label">{{ $t('total quota') | capitalize }}:</span>
                    <span class="betslip__controls-events-info-number">{{ totalCoefficient }}</span>
                </div>
            </div>
        </div>
        <div class="betslip__controls-right">
            <button
                v-if="!isOfflineTicket"
                @click="$emit('close')"
                class="betslip__controls-action"
            >
                <span>{{ $t('close the preview') | capitalize }}</span>
                <i class="icon icon-close"></i>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Toolbar',
        props: {
            selectionsCount: {
                type: Number,
                required: true,
            },
            undoSelections: {
                type: Array,
                required: false,
                default: null
            },
            selectionNames: {
                type: String,
                required: true,
            },
            isOfflineTicket: {
                type: Boolean,
                required: false,
                default: false,
            },
            totalCoefficient: {
                type: String,
                required: false,
                default: null,
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/Toolbar.vue